<template>
  <nav class="nav-bar">
    <div class="nav-container">
      <!-- Left side: Brand -->
      <div class="nav-left">
        <div class="brand">
          <span class="brand-name">RentalKenya</span>
        </div>
      </div>

      <!-- Mobile Menu Button -->
      <button class="mobile-menu-btn" 
      v-if="!mobileMenuOpen"
      @click="toggleMobileMenu"
      aria-label="Open menu"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
        </svg>
      </button>

      <button class="mobile-menu-btn" 
      v-if="mobileMenuOpen"
      @click="closeMobileMenu"
      aria-label="Close Menu"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
        </svg>
      </button>

      <!-- Right side: Navigation links -->
      <div class="nav-right" :class="{ 'mobile-open': mobileMenuOpen }">
        <router-link to="/dashboard" class="nav-link" @click="closeMobileMenu">
          <i class="bi bi-speedometer2"></i>
          <span>Dashboard</span>
        </router-link>
        
        <router-link to="/houses" class="nav-link" @click="closeMobileMenu">
          <i class="bi bi-building"></i>
          <span>Houses</span>
        </router-link>
        
        <router-link to="/tenants" class="nav-link" @click="closeMobileMenu">
          <i class="bi bi-people"></i>
          <span>Tenants</span>
        </router-link>

        <!-- SMS Dropdown -->
        <div class="dropdown" @mouseenter="showSmsDropdown = true" @mouseleave="showSmsDropdown = false">
          <router-link to="/sms/history" class="nav-link dropdown-trigger" @click="closeMobileMenu">
            <i class="bi bi-chat-dots"></i>
            <span>SMS</span>
            <i class="bi bi-chevron-down dropdown-icon"></i>
          </router-link>
          
          <div class="dropdown-menu" v-show="showSmsDropdown">
            <router-link to="/tenants/sms" class="dropdown-item" @click="closeMobileMenu">
              <i class="bi bi-envelope-paper"></i>
              <span>Send SMS</span>
            </router-link>
            <router-link to="/sms/history" class="dropdown-item" @click="closeMobileMenu">
              <i class="bi bi-clock-history"></i>
              <span>SMS History</span>
            </router-link>
          </div>
        </div>

        <router-link to="/upload/unitswithtenants" class="nav-link" @click="closeMobileMenu">
          <i class="bi bi-cloud-upload"></i>
          <span>Upload</span>
        </router-link>
        
        <router-link to="/profile" class="nav-link" @click="closeMobileMenu">
          <i class="bi bi-person-circle"></i>
          <span>Profile</span>
        </router-link>

        <router-link to="/help" class="nav-link" @click="closeMobileMenu">
          <i class="bi bi-life-preserver"></i>
          <span>Help &amp; Support</span>
        </router-link>
        
        <button class="nav-link logout" @click="handleLogout">
          <i class="bi bi-box-arrow-right"></i>
          <span>Logout</span>
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavigationBar',
  
  data() {
    return {
      showSmsDropdown: false,
      mobileMenuOpen: false
    };
  },
  
  methods: {
    handleLogout() {
      console.log('Logging out...');
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      this.$router.push("/");
    },
    
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      this.showSmsDropdown = false;
    }
  }
};
</script>

<style scoped>
.nav-bar {
  background: var(--dash-surface);
  padding: 0;
  box-shadow: var(--dash-shadow-xs);
  border-bottom: 1px solid var(--dash-line);
  position: sticky;
  top: 0;
  z-index: 1000;
  font-family: var(--dash-font);
}

.nav-container {
  max-width: var(--dash-maxw);
  margin: 0 auto;
  padding: 0 var(--dash-gutter);
  height: var(--dash-nav-h);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  gap:20px;
}

/* Left side: Brand */
.nav-left {
  display: flex;
  align-items: center;
}

.brand {
  display: flex;
  align-items: center;
}

/* Solid wordmark — a gradient-filled brand name is the fastest way to make a
   product look unfinished. Ink type with a single blue accent instead. */
.brand-name {
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--dash-ink);
  letter-spacing: -0.02em;
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
}

.brand-name::after {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--dash-primary);
  align-self: center;
  margin-left: 4px;
}

/* Mobile Menu Button */
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--dash-muted);
  padding: 8px;
}

/* Right side: Navigation links */
.nav-right {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 2rem;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  text-decoration: none;
  color: var(--dash-muted);
  font-weight: 550;
  border-radius: var(--dash-radius-xs);
  transition: background var(--dash-t), color var(--dash-t);
  font-size: var(--dash-fs-sm);
  border: none;
  background: none;
  cursor: pointer;
  font-family: inherit;
  position: relative;
}

.nav-link i {
  font-size: 1.1rem;
}

.nav-link:hover {
  background: var(--dash-bg-alt);
  color: var(--dash-ink);
}

/* Active tab: a quiet blue chip, not a saturated slab */
.nav-link.router-link-active {
  background: var(--dash-primary-soft);
  color: var(--dash-primary-ink);
  font-weight: 650;
}

.nav-link.router-link-active i {
  color: var(--dash-primary);
}

/* Dropdown */
.dropdown {
  position: relative;
}

.dropdown-trigger {
  position: relative;
}

.dropdown-icon {
  font-size: 0.8rem;
  transition: transform 0.2s ease;
}

.dropdown:hover .dropdown-icon {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: var(--dash-surface);
  border-radius: var(--dash-radius-sm);
  box-shadow: var(--dash-shadow);
  min-width: 200px;
  overflow: hidden;
  z-index: 100;
  animation: dropdownFade 0.2s ease;
  border: 1px solid var(--dash-line);
}

@keyframes dropdownFade {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  text-decoration: none;
  color: var(--dash-muted);
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.dropdown-item i {
  font-size: 1.1rem;
  width: 20px;
}

.dropdown-item:hover {
  background: var(--dash-bg-alt);
  color: var(--dash-primary);
}

/* Logout button */
.nav-link.logout {
  color: var(--dash-danger);
}

.nav-link.logout:hover {
  background: var(--dash-danger-soft);
  color: var(--dash-danger-ink);
}

/* Responsive */
@media (max-width: 1024px) {
  .nav-link {
    padding: 10px 16px;
    font-size: 0.9rem;
  }
  
  .nav-link span {
    display: none;
  }
  
  .nav-link i {
    font-size: 1.3rem;
    margin: 0;
  }
  
  .dropdown-item span {
    display: inline;
  }
  
  .dropdown-item i {
    font-size: 1.1rem;
  }
}

@media (max-width: 768px) {
  .nav-container {
    padding: 0 16px;
    height: 60px;
  }
  
  .brand-name {
    font-size: 1.3rem;
  }
  
  .mobile-menu-btn {
    display: block;
  }
  
  .nav-right {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    background: white;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    z-index: 999;
  }
  
  .nav-right.mobile-open {
    max-height: 500px;
    overflow-y: auto;
  }
  
  .nav-link {
    padding: 14px 20px;
    border-radius: 0;
    justify-content: flex-start;
  }
  
  .nav-link span {
    display: inline;
  }
  
  .nav-link i {
    font-size: 1.2rem;
    width: 24px;
  }
  
  .dropdown {
    width: 100%;
  }
  
  .dropdown-menu {
    position: static;
    box-shadow: none;
    border: none;
    padding-left: 44px;
    background: var(--dash-surface-2);
    animation: none;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease;
  }
  
  .dropdown:hover .dropdown-menu {
    max-height: 200px;
  }
  
  .dropdown-item {
    padding: 10px 16px;
  }
  
  .dropdown-icon {
    margin-left: auto;
  }
}

@media (max-width: 480px) {
  .brand-name {
    font-size: 1.1rem;
  }
  
  .nav-link {
    padding: 12px 16px;
    font-size: 0.9rem;
  }
}
</style>